import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";
import { emitPlanLimitIfAny } from "../../../utils/planLimit/emitPlanLimit";

/**
 * Instancia de axios configurada con interceptores para:
 * - Obtener token fresco de localStorage en cada request
 * - Manejar errores 401 (unauthorized)
 * - Timeout de 15 segundos
 */
const axiosInstance: AxiosInstance = axios.create({
  baseURL: "",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

// URLs para redirecciones de error
const LOGIN_URL = window.location.origin + "/";

/**
 * Request Interceptor
 * Obtiene el token fresco de localStorage en CADA request
 * Esto soluciona el problema del token estatico que se obtenia una sola vez al cargar el modulo
 */
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    // Obtener token fresco de localStorage en cada request
    const token = localStorage.getItem("access_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
  }
);

/**
 * Response Interceptor
 * Maneja errores de autenticacion y servidor
 */
axiosInstance.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  (error: AxiosError): Promise<AxiosError> => {
    const status = error.response?.status;

    if (status === 401) {
      // Token expirado o invalido - limpiar storage y redirigir a login
      localStorage.clear();
      window.location.href = LOGIN_URL;
    }

    // Spec 007: límite de plan (cajas/almacenes/usuarios) → modal global con
    // el adicional y el plan superior (PlanLimitPrompt en MenuWrapper).
    emitPlanLimitIfAny(error.response?.data);

    return Promise.reject(error);
  }
);

export default axiosInstance;
